import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgslCarouselComponent, CarouselItemElement, CarouselDotElement } from './ngsl-carousel.component';
import { NgslCarouselItemDirective } from './ngsl-carousel-item.directive';
import { NgslCarouselDotDirective } from './ngsl-carousel-dot.directive';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    NgslCarouselComponent,
    NgslCarouselItemDirective,
    NgslCarouselDotDirective,
    CarouselItemElement,
    CarouselDotElement
  ],
  exports: [
    NgslCarouselComponent,
    NgslCarouselItemDirective,
    NgslCarouselDotDirective,
    CarouselItemElement,
    CarouselDotElement
  ]

})
export class NgslCarouselModule { }
